'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getConnections = exports.getConnections = function getConnections(state) {
  return state.get('connections');
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/reducers/connectionsSelector.js
// module id = 678
// module chunks = 0